import { Edge, Node } from 'reactflow';
import { BaseNodeProps } from 'types';

export const getNodesIds = (nodes: Node<BaseNodeProps>[]) => nodes.map((node) => node.id);
export const getEdgesIds = (edges: Edge[]) => edges.map((edge) => edge.id);
